import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { DocumentsPostingInfoResponse } from 'types/api/mypage/documentsPostingInfo';

/** 書面交付情報取得APIのURL */
const url = ApiUrl.Read.DOCUMENTS_POSTING_INFO;

/**
 * 書面交付情報取得APIの呼び出しフック。
 * 電子交付・郵送交付の対象帳票一覧を取得する。
 *
 * @returns execute - API実行関数
 */
const UseGetDocumentsPostingInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<DocumentsPostingInfoResponse[]>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default UseGetDocumentsPostingInfo;
